export const updateAuthTypeSelected = (value: boolean, callback?: (value: boolean) => void) => {
	sessionStorage.setItem('isAuthSelected', String(value));
	callback?.(value);
};
